import Image from 'next/image'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useExperimentalAddStaticFileHost } from '../../../../experiments/new-cdn-experiment/useExperimentalAddStaticFileHost'
import { type StoryblokBrandLogoType } from '../../../storyblok'

const getBrandPageProductSearchBrandLogoPath = (
  brandLogo: string | undefined,
): string | null => {
  if (!brandLogo) {
    return null
  }

  return `brand-logos/${brandLogo}`
}

export const StoryblokBrandProductSearchBrandLogo: FC<{
  brandLogoRootBlock: StoryblokBrandLogoType[] | undefined
  title?: string
}> = ({ brandLogoRootBlock, title }) => {
  const brandLogo = brandLogoRootBlock?.[0]
  const intl = useIntl()

  const { addStaticCdnHostToUrl } = useExperimentalAddStaticFileHost()

  if (!brandLogo) {
    return null
  }

  const brandLogoUrl = getBrandPageProductSearchBrandLogoPath(
    brandLogo.legacyImageSrc,
  )

  if (!brandLogoUrl) {
    return null
  }

  return (
    <div className="relative flex h-[150px] w-full max-w-[280px] items-center justify-center">
      <Image
        alt={intl.formatMessage(
          {
            id: 'brandPage.logo.altText',
          },
          { brandName: title ?? '' },
        )}
        className="object-contain"
        fill
        loading="lazy"
        src={addStaticCdnHostToUrl(brandLogoUrl)}
        unoptimized
      />
    </div>
  )
}
